import { DateTime } from 'luxon';

export function getEventDateKey(eventDate) {
  if (!eventDate) return null;
  if (eventDate instanceof Date) {
    return Number.isNaN(eventDate.getTime()) ? null : eventDate.toISOString().slice(0, 10);
  }

  return String(eventDate).match(/^(\d{4}-\d{2}-\d{2})/)?.[1] || null;
}

export function formatEventDate(eventDate) {
  const dateKey = getEventDateKey(eventDate);
  if (!dateKey) return '';

  const date = DateTime.fromISO(dateKey, { zone: 'UTC' });
  return date.isValid ? date.setLocale('en-GB').toFormat('d LLLL yyyy') : '';
}